import { render, staticRenderFns } from "./BeefCattleSmallDetailModal1.vue?vue&type=template&id=32454c94"
import script from "./BeefCattleSmallDetailModal1.vue?vue&type=script&lang=js"
export * from "./BeefCattleSmallDetailModal1.vue?vue&type=script&lang=js"
import style0 from "./BeefCattleSmallDetailModal1.vue?vue&type=style&index=0&id=32454c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports